import { useTranslation } from 'react-i18next'

import { TreeIcon } from '@phosphor-icons/react'

import { CheckboxOptionCard } from '@reveni-io/reveni-ui'

import { carbonOffsetFeeInputName, defaultCarbonOffsetFee } from './constants'
import { getCarbonOffsetFeeAmount } from './helpers'

const CarbonOffsetFeeConfiguration = ({ onChange, config, defaultStoreCurrency }) => {
  const { t, i18n } = useTranslation()

  const amount = getCarbonOffsetFeeAmount({ config, defaultStoreCurrency, language: i18n.language })

  const handleChange = checked => onChange({ carbon_offset_fee: checked ? defaultCarbonOffsetFee : null })

  return (
    <CheckboxOptionCard
      icon={<TreeIcon size={24} weight="thin" />}
      title={t('Huella de carbono')}
      description={t(
        'Los clientes verán la opción de compensar la huella de carbono de su devolución por {{amount}}.',
        { amount }
      )}
      name={carbonOffsetFeeInputName}
      selected={!!config?.carbon_offset_fee}
      onChange={handleChange}
    />
  )
}

export default CarbonOffsetFeeConfiguration
